import React from 'react';
import { observer } from 'mobx-react';
import { FormControl, FormLabel, Stack, Switch } from '@chakra-ui/react';
import { clientStore } from 'apps/client/app';

export const ChangeRoleAction = observer(() => {
  /* Widget which allows intermediators to switch between requesting as their own user or the intermediator role. */
  let switcher = null;
  if (clientStore.hasRole('INTERMEDIATOR')) {
    let text;
    if (clientStore.currentPortal === 'INTERMEDIATOR') {
      text = 'Viewing as intermediator';
    } else {
      text = `Viewing as ${clientStore?.tokenData?.jwtData?.user_name}`;
    }
    switcher = (
      <Stack align='center' direction='row'>
        <FormControl display='flex' alignItems='center'>
          <FormLabel htmlFor='email-alerts' mb='0'>
            {text}
          </FormLabel>
          <Switch
            id='email-alerts'
            data-test-id='change-role-switch'
            isChecked={clientStore.currentPortal === 'INTERMEDIATOR'}
            onChange={clientStore.ToggleCurrentPortal}
          />
        </FormControl>
      </Stack>
    );
  }
  return switcher;
});
